import React, { useState } from "react";
import useStyles from "style/js-style/containers/administration/roles/privileges/EventPrivilegeBlockStyle";
import EAIcon from "components/common/EAIcon";
import RoleCheckBox from "./RoleCheckBox";
import {isEmpty} from "lodash";
import i18next from "i18next";
import { FormControlLabel, Switch } from "@mui/material";
import { EVENT_CHECK_INDETERMINED } from "services/common/RolesUtils";

/**
 *
 * @param data
 * @param grantMode disable | hide
 * @param variant roles | profile
 * @returns {JSX.Element}
 * @constructor
 */
function EventPrivilegeBlock({ data, grantMode = "disable", variant, openDefault = false }) {
  const { classes } = useStyles();
  const [isOpen, setIsOpen] = useState(openDefault);

  if(isEmpty(data.items) && data.variant !== "subDropProperties") {
    return (data.isGrantable || grantMode === "disable") && <RoleCheckBox item={data} variant={variant}/>
  }

  const handleSelectAll = (e) => {
    e.stopPropagation();
    data.selectAllAction();
  }

  const isActive = (item) => {
    return item.isActive === EVENT_CHECK_INDETERMINED ? false : item.isActive;
  }

  const getNumberOfActiveItems = (items) => {
    let totalLength = 0;
    items?.forEach(item => {
      if (item.items && Array.isArray(item.items)) {
          totalLength += getNumberOfActiveItems(item.items);
      }
      if(isActive(item) && item.isGrantable) {
        totalLength += 1;
      }
    });
    return totalLength;
  }

  const handleUnselectAll = (e) => {
    e.stopPropagation();
    data.unselectAllAction();
  }

  return (data.isGrantable || grantMode === "disable") && (
    <div
      className={classes[`panelRoot-${data.variant}`]}
      style={{backgroundColor: data.backgroundColor ? data.backgroundColor : ""}}
    >
      <div className={classes[`panelHeader-${data.variant}`]}>
        <div>
          <RoleCheckBox item={data} variant={variant}/>
        </div>
        <div style={{display: "flex", flexWrap: "nowrap", alignItems: "center"}}>
          { data.hasSelectActions && (
            <>
              <span
                className={classes.dropPanelActionItem}
                onClick={handleSelectAll}
              >
                {i18next.t("userProfile.selectAll")}
              </span>
              <span
                className={classes.dropPanelActionItem}
                onClick={handleUnselectAll}
              >
                {i18next.t("userProfile.unselect")}({getNumberOfActiveItems(data.items)})
              </span>
            </>
          )}
          {data.toggleAllPropertiesAndFuture!== undefined &&
              <span>
                  <FormControlLabel labelPlacement="start" label={i18next.t("privileges.selectedAllPropertiesAndFuture") + data.namePropertyPlurial}
                    disabled={!isActive(data) || !data.hasPrivilegeAllPropertiesAndFuture} className={classes.labelAllPropertiesAndFuture} control={
                    <Switch checked={data.isAllPropertiesAndFuture} onChange={data.toggleAllPropertiesAndFuture} size="small" className={classes.switchAllPropertiesAndFuture}/>
                    }  />
              </span>
          }
          
          <span>
            <EAIcon
              icon={"arrow/arrow-to-up_large"}
              style={{rotate: isOpen ? "" : "180deg", cursor: "pointer"}}
              onClick={() => setIsOpen(!isOpen)}
            />
          </span>
        </div>
      </div>

      {/* Content */}
      {isOpen &&
        <div className={classes[`itemsWrapper-${data.variant}`]}>
          {data.items.map((item, index) => (
            <EventPrivilegeBlock
              key={index}
              data={item}
              grantMode={grantMode}
              variant={variant}
              openDefault={item.openDefault}

            />
          ))}
          {/* For event attributes/indicators without properties, show message */}
          {isEmpty(data.items) && data.variant === "subDropProperties" &&
            <div className={classes.noPropertiesAvailabled}>
              {i18next.t("privileges.noPropertiesAvailable", {nameProperty : data.namePropertySingular})}
              <br/>
              {i18next.t("privileges.noPropertiesAvailableComment")}
              
            </div>
          }
        </div>
      }
    </div>
  )
}

export default EventPrivilegeBlock;
